<template>
  <v-fade-transition :hide-on-leave="true">
    <div
      class="toc-sublayer-item"
      :style="{ opacity: sublayerIsVisibleAtCurrentScale ? 1.0 : 0.4 }"
    >
      <v-hover
        v-if="sublayer.legendImages && sublayer.legendImages.length == 1"
      >
        <v-list-tile
          slot-scope="{ hover }"
          class="first-level tile"
          style=" max-width: 392px; padding-right: 0px;cursor: pointer;max-height: 40px;"
          avatar
          :style="{ marginLeft: addMargin ? '20px' : '' }"
        >
          <v-list-tile-avatar size="20">
            <img
              :alt="'Kartlag symbolikk ' + sublayer.title"
              v-if="sublayer.legendImages"
              :src="
                'data:image/png;base64, ' + sublayer.legendImages[0].imageData
              "
            />
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title
              :title="'Navn: ' + sublayer.title"
              style="font-size: 12px !important; margin-left: 10px;"
              v-html="sublayer.title"
            ></v-list-tile-title>
          </v-list-tile-content>

          <v-spacer></v-spacer>

          <v-tooltip bottom open-delay="800" close-delay="0">
            <template v-slot:activator="{ on }">
              <v-list-tile-action
                v-on="on"
                style="min-width: 30px;"
                class="pa-0 ma-0"
                v-show="hover"
              >
                <v-btn
                  class="pa-0 ma-0"
                  icon
                  small
                  aria-label="Vis beskrivelse og egenskaper"
                  flat
                  @click.stop="showMetadata"
                >
                  <v-icon size="20">mdi-information-variant</v-icon>
                </v-btn>
              </v-list-tile-action>
            </template>
            <span>Vis beskrivelse og egenskaper</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="800" close-delay="0">
            <template v-slot:activator="{ on }">
              <v-list-tile-action
                v-on="on"
                style="min-width: 30px;"
                class="pa-0 ma-0"
                v-show="hover"
              >
                <v-btn
                  @click.stop="showTable"
                  class="pa-0 ma-0"
                  icon
                  aria-label="Vis tabell"
                  small
                  flat
                >
                  <v-icon size="18">mdi-table-large</v-icon>
                </v-btn>
              </v-list-tile-action>
            </template>
            <span>Vis tabell</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="800" close-delay="0">
            <template v-slot:activator="{ on }">
              <v-list-tile-action
                v-on="on"
                style="min-width: 30px;"
                class="pa-0 ma-0"
                v-show="hover || filterActive"
              >
                <v-btn
                  @click.stop="showFilterDialog"
                  class="pa-0 ma-0"
                  icon
                  aria-label="Filtrer kartlag"
                  small
                  flat
                >
                  <v-icon size="18" :color="filterActive ? 'blue' : ''">{{
                    filterActive ? "mdi-filter" : "mdi-filter-outline"
                  }}</v-icon>
                </v-btn>
              </v-list-tile-action>
            </template>
            <span>Sett filter</span>
          </v-tooltip>

          <v-tooltip bottom open-delay="800" close-delay="0">
            <template v-slot:activator="{ on }">
              <v-list-tile-action v-on="on" style="min-width: 30px;">
                <v-btn
                  icon
                  small
                  label="Slå kartlag av/på"
                  aria-label="Slå kartlag av/på"
                  flat
                  @click.stop="toggleSublayerVisibility(sublayer)"
                >
                  <v-icon
                    :color="
                      visible &&
                      sublayerIsVisibleAtCurrentScale &&
                      parentIsVisible
                        ? 'blue'
                        : 'grey'
                    "
                    style="font-size: 20px;"
                    >{{ visible ? "mdi-eye" : "mdi-eye-off" }}</v-icon
                  >
                </v-btn>
              </v-list-tile-action>
            </template>
            <span>Skru kartlag av/på</span>
          </v-tooltip>
        </v-list-tile>
      </v-hover>

      <v-list-group avatar v-else :value="visible" v-model="open">
        <template v-slot:activator>
          <v-hover>
            <v-list-tile slot-scope="{ hover }">
              <v-list-tile-avatar size="20">
                <v-icon color="dark-grey" size="20">{{
                  open ? "mdi-folder-open-outline" : "mdi-folder-outline"
                }}</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title
                  style="font-size: 12px !important; margin-left: 10px; font-weight: bold"
                  :title="
                    'Navn: ' +
                      (sublayer.title !== null ? sublayer.title : sublayer.name)
                  "
                  v-html="
                    sublayer.title !== null ? sublayer.title : sublayer.name
                  "
                ></v-list-tile-title>
              </v-list-tile-content>

              <v-spacer></v-spacer>

              <v-tooltip bottom open-delay="800" close-delay="0">
                <template v-slot:activator="{ on }">
                  <v-list-tile-action
                    v-on="on"
                    style="min-width: 30px;"
                    class="pa-0 ma-0"
                    v-show="hover"
                  >
                    <v-btn
                      class="pa-0 ma-0"
                      icon
                      small
                      aria-label="Vis beskrivelse og egenskaper"
                      flat
                      @click.stop="showMetadata"
                    >
                      <v-icon size="20">mdi-information-variant</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </template>
                <span>Vis beskrivelse og egenskaper</span>
              </v-tooltip>

              <v-tooltip bottom open-delay="800" close-delay="0">
                <template v-slot:activator="{ on }">
                  <v-list-tile-action
                    v-on="on"
                    v-if="
                      sublayer.legendImages !== undefined &&
                        sublayer.legendImages.length > 0
                    "
                    style="min-width: 30px;"
                    class="pa-0 ma-0"
                    v-show="hover"
                  >
                    <v-btn
                      @click.stop="showTable"
                      class="pa-0 ma-0"
                      icon
                      aria-label="Vis tabell"
                      small
                      flat
                    >
                      <v-icon size="18">mdi-table-large</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </template>
                <span>Vis tabell</span>
              </v-tooltip>

              <v-tooltip bottom open-delay="800" close-delay="0">
                <template v-slot:activator="{ on }">
                  <v-list-tile-action
                    v-on="on"
                    v-if="
                      sublayer.legendImages !== undefined &&
                        sublayer.legendImages.length > 0
                    "
                    style="min-width: 30px;"
                    class="pa-0 ma-0"
                    v-show="hover || filterActive"
                  >
                    <v-btn
                      @click.stop="showFilterDialog"
                      class="pa-0 ma-0"
                      icon
                      aria-label="Filtrer kartlag"
                      small
                      flat
                    >
                      <v-icon size="18" :color="filterActive ? 'blue' : ''">{{
                        filterActive ? "mdi-filter" : "mdi-filter-outline"
                      }}</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </template>
                <span>Filtrer kartlag</span>
              </v-tooltip>

              <v-tooltip bottom open-delay="800" close-delay="0">
                <template v-slot:activator="{ on }">
                  <v-list-tile-action v-on="on" style="min-width: 30px;">
                    <v-btn
                      icon
                      small
                      label="Slå kartlag av/på"
                      aria-label="Slå kartlag av/på"
                      flat
                      @click.stop="toggleSublayerVisibility(sublayer)"
                    >
                      <v-icon
                        :color="
                          visible &&
                          sublayerIsVisibleAtCurrentScale &&
                          parentIsVisible
                            ? 'blue'
                            : 'grey'
                        "
                        style="font-size: 20px;"
                        >{{ visible ? "mdi-eye" : "mdi-eye-off" }}</v-icon
                      >
                    </v-btn>
                  </v-list-tile-action>
                </template>
                <span>Skru kartlag av/på</span>
              </v-tooltip>
            </v-list-tile>
          </v-hover>
        </template>

        <!-- Legg til style="margin-left: 15px;" for å ha margin fra venstre -->
        <div
          v-if="
            sublayer.legendImages !== undefined &&
              sublayer.legendImages.length > 0
          "
        >
          <v-list-tile
            style="height: auto !important; max-height: 35px;"
            :title="'Navn: ' + subLegend.label"
            v-for="subLegend in sublayer.legendImages"
            :key="subLegend.label"
            @click="toggleSublayerVisibility(sublayer)"
          >
            <v-list-tile-avatar size="20">
              <img
                :alt="'Kartlag symbolikk ' + subLegend.label"
                :src="'data:image/png;base64, ' + subLegend.imageData"
              />
            </v-list-tile-avatar>

            <v-list-tile-content
              style="font-size: 12px !important; margin-left: 10px;"
            >
              <v-list-tile-title>{{ subLegend.label }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>

        <div
          style="margin-left: 15px;"
          v-if="
            sublayer.legendImages !== undefined &&
              sublayer.legendImages.length == 0 &&
              sublayer.sublayers !== undefined &&
              sublayer.sublayers.items.length > 0
          "
        >
          <v-list-tile
            :style="{ marginLeft: addMargin ? '20px' : '' }"
            class="sub-tile"
            v-for="(subsublayer,
            index) in sublayer.sublayers.items.slice().reverse()"
            :key="index + 'sublayer'"
          >
            <layer-list-item-toc-sublayer
              :sublayer="subsublayer"
              :parent-is-visible="visible && parentIsVisible"
              :id="id"
              :addMargin="true"
              :visibility="subsublayer.visible"
              @visible="$emit('visible')"
            ></layer-list-item-toc-sublayer>
          </v-list-tile>
        </div>
        <div v-else v-show="sublayer.hasOwnProperty('legendUrl')">
          <img
            :alt="'Kartlag symbolikk ' + sublayer.title"
            class="pl-3"
            :src="sublayer.legendUrl"
          />
        </div>
      </v-list-group>

      <div class="text-xs-center">
        <layer-metadata
          v-if="dialog"
          :open="dialog"
          :layer="sublayer"
          @close="dialog = false"
        ></layer-metadata>
        <layer-item-filter
          v-if="filterDialog"
          :open="filterDialog"
          :layer="sublayer"
          @filter-active-changed="setFilterActive"
          @close="filterDialog = false"
        ></layer-item-filter>
      </div>
    </div>
  </v-fade-transition>
</template>

<script>
import LayerMetadata from "@/pages/MapPage/Tools/Layers/LayerMetadata";
import LayerItemFilter from "@/pages/MapPage/Tools/Layers/LayerItemFilter.vue";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "LayerListItemTocSublayer",
  data: function() {
    return {
      visible: false,
      dialog: false,
      open: false,
      filterDialog: false,
      items: [
        { title: "Vis metadata", value: "metadata" },
        { title: "Vis tabell", value: "tabell" },
        { title: "Sett filter", value: "filtrer" }
      ],
      filterActive: false
    };
  },
  computed: {
    ...mapGetters(["getSublayerVisibility"]),
    ...mapState(["currentMapScale"]),
    sublayerVisibility() {
      return this.getSublayerVisibility(this.id, this.sublayer.id);
    },
    sublayerIsVisibleAtCurrentScale() {
      // wms layers does not provide min and max scale - therefore it must always be visible
      if (this.sublayer.parent.type === "wms") {
        return true;
      }
      if (this.sublayer.maxScale === 0 && this.sublayer.minScale === 0) {
        return true;
      } else {
        return (
          (this.sublayer.maxScale <= this.currentMapScale ||
            this.sublayer.maxScale === 0) &&
          (this.sublayer.minScale >= this.currentMapScale ||
            this.sublayer.minScale === 0)
        );
      }
    }
  },
  props: {
    id: String,
    sublayer: Object,
    parentIsVisible: Boolean,
    addMargin: {
      default: false,
      type: Boolean
    }
  },
  components: {
    LayerMetadata,
    LayerItemFilter
  },
  methods: {
    ...mapActions([
      "addBottomSheet",
      "setShowTabs",
      "setShowSideMenu",
      "setProfileVisibility"
    ]),
    showMetadata: function() {
      this.dialog = true;
    },
    setFilterActive: function(filterActive) {
      this.filterActive = filterActive;
    },
    menuItemSelected: function(item) {
      if (item.value == "metadata") {
        this.dialog = true;
      }
      if (item.value == "filtrer") {
        this.showFilterDialog();
      }
      if (item.value == "tabell") {
        this.addBottomSheet({
          type: "featureTable",
          title: this.sublayer.title,
          url: this.sublayer.layer.url,
          id: this.sublayer.id,
          parentLayerID: this.sublayer.layer.id
        });
        this.setShowTabs(true);
      }
    },
    showTable: function() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.setShowSideMenu(false);
      }
      this.addBottomSheet({
        type: "featureTable",
        title: this.sublayer.title,
        url: this.sublayer.layer.url,
        id: this.sublayer.id,
        parentLayerID: this.sublayer.layer.id
      });
      this.setShowTabs(true);
    },
    showFilterDialog: function() {
      this.filterDialog = true;
    },
    toggleSublayerVisibility: function(sublayer) {
      sublayer.visible = !sublayer.visible;
      if (sublayer.visible) {
        this.$emit("visible");
        this.setProfileVisibility({
          profile: { id: sublayer.layer.id },
          visible: true
        });
      }
    },
    loadSublayer: function() {
      this.visible = this.sublayer.visible;
      this.open = this.visible;

      this.sublayer.watch("visible", newValue => {
        this.visible = newValue;
      });

      this.sublayer.watch("definitionExpression", newValue => {
        this.filterActive = newValue !== null && newValue !== "";
      });
    }
  },
  watch: {
    sublayer: function() {
      this.loadSublayer();
    },
    visible: function(newVal) {
      this.open = newVal;
    }
  },
  mounted() {
    this.loadSublayer();
  }
};
</script>

<style lang="scss">
.v-list {
  padding: 0px !important;
}

.toc-sublayer-item {
  width: 100%;
  .v-list__group__header__append-icon {
    display: none !important;
  }

  .v-list__tile {
    min-height: 35px;
    height: 35px;
  }

  .v-list__tile__content {
    min-height: 35px;
    max-height: 35px;
  }

  .sub-tile .v-list__tile {
    padding-right: 8px;
    padding-left: 8px;
    height: auto;
  }

  .v-list__tile__avatar {
    min-width: 20px;
  }
}

.tile:hover {
  background: rgba(0, 0, 0, 0.04);
}

.v-list__tile {
  overflow: hidden;
  min-height: 48px;
}
</style>
